(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nosto-placements"] && !Shopify.designMode) return;
  try {
    
  let debounceTimer;

  function afterNostoCardInjected() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (window.lazySizes && typeof lazySizes.init === 'function') {
        lazySizes.init();
      }
      if (window.AOS && typeof AOS.refreshHard === 'function') {
        AOS.refreshHard();
      }
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        try { window._swat.initializeActionButtons('.nosto-placements'); } catch (e) {}
      }
      if (typeof window.__initProductGridCarousels === 'function') {
        window.__initProductGridCarousels();
      }
      if (typeof window.__resizeProductGridCarousels === 'function') {
        window.__resizeProductGridCarousels();
        setTimeout(window.__resizeProductGridCarousels, 250);
        setTimeout(window.__resizeProductGridCarousels, 800);
      }
      window.dispatchEvent(new Event('scroll'));
    }, 100);
  }

  document.addEventListener('@nosto/DynamicCard/loaded', afterNostoCardInjected, true);

  // Nosto campaign loader. Mirrors <nosto-campaign> but passes skipEvents so the
  // recommendation fetch does not re-record the page's view-product event.
  (function () {
    if (window.__nostoCampaignLoaderBound) return;
    window.__nostoCampaignLoaderBound = true;

    window.nostojs =
      window.nostojs ||
      function (cb) {
        (window.nostojs.q = window.nostojs.q || []).push(cb);
      };

    var BATCH_MS = 50;
    var queue = [];
    var timer = null;

    function escapeAttr(value) {
      return String(value == null ? '' : value).replace(/"/g, '&quot;');
    }

    function buildMarkup(products, itemWidth) {
      var items = products
        .map(function (product) {
          if (!product || !product.handle) return '';
          return (
            '<div class="grid__item ' + escapeAttr(itemWidth) + '">' +
            '<nosto-dynamic-card handle="' + escapeAttr(product.handle) + '" section="nosto-product-card"></nosto-dynamic-card>' +
            '</div>'
          );
        })
        .join('');
      if (!items) return '';
      return (
        '<div class="grid-overflow-wrapper">' +
        '<div class="nosto-placements__carousel grid grid--uniform" data-nosto-carousel>' +
        items +
        '</div>' +
        '</div>'
      );
    }

    function render(el, campaign) {
      var products = campaign && campaign.products;
      if (!products || !products.length) return;
      var markup = buildMarkup(products, el.getAttribute('data-nosto-item-width') || '');
      if (!markup) return;
      el.innerHTML = markup;
      window.nostojs(function (api) {
        if (typeof api.attributeProductClicksInCampaign !== 'function') return;
        try {
          api.attributeProductClicksInCampaign(el, campaign);
        } catch (e) {}
      });
    }

    function flush() {
      timer = null;
      var batch = queue.slice();
      queue = [];
      if (!batch.length) return;

      window.nostojs(function (api) {
        if (typeof api.createRecommendationRequest !== 'function') return;
        api
          .createRecommendationRequest({ includeTagging: true })
          .disableCampaignInjection()
          .setElements(
            batch.map(function (el) {
              return el.getAttribute('data-nosto-placement');
            })
          )
          .setResponseMode('JSON_ORIGINAL')
          // The whole point: this request is a fetch, not a report. Without it the
          // page's view-product event is transmitted a second time.
          .load({ skipEvents: true })
          .then(function (result) {
            var recommendations = (result && result.recommendations) || {};
            batch.forEach(function (el) {
              render(el, recommendations[el.getAttribute('data-nosto-placement')]);
            });
          })
          .catch(function () {});
      });
    }

    function enqueue(el) {
      if (el.__nostoRequested) return;
      el.__nostoRequested = true;
      queue.push(el);
      if (timer === null) timer = setTimeout(flush, BATCH_MS);
    }

    function bind(el) {
      if (el.__nostoBound) return;
      el.__nostoBound = true;

      if (el.getAttribute('data-nosto-cart-synced') === 'true') {
        window.nostojs(function (api) {
          if (typeof api.listen !== 'function') return;
          api.listen('cartupdated', function () {
            el.__nostoRequested = false;
            enqueue(el);
          });
        });
      }

      if (el.getAttribute('data-nosto-lazy') === 'true' && typeof IntersectionObserver !== 'undefined') {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          enqueue(el);
        });
        observer.observe(el);
        return;
      }

      enqueue(el);
    }

    function init() {
      var els = document.querySelectorAll('[data-nosto-placement]');
      Array.prototype.forEach.call(els, bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  function applyTagalysSearchVisibility(root, detail) {
    const d = detail || {};
    if (d.noQuery || d.empty) {
      root.classList.remove('nosto-placements__item--tagalys-hidden');
    } else {
      root.classList.add('nosto-placements__item--tagalys-hidden');
    }
  }

  window.addEventListener('tagalys:search-results', (e) => {
    document.querySelectorAll('[data-nosto-tagalys-search-visibility]').forEach(root => {
      applyTagalysSearchVisibility(root, e.detail);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-banner"] && !Shopify.designMode) return;
  try {
    
  var readMoreContainer = document.querySelector('[data-read-more-container]');
  if (readMoreContainer) {
    var readMoreTruncated = readMoreContainer.querySelector('[data-read-more-truncated]');
    var readMoreFull = readMoreContainer.querySelector('[data-read-more-full]');
    var readMoreButtons = readMoreContainer.querySelectorAll('[data-read-more-toggle]');

    readMoreButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        readMoreTruncated.classList.toggle('visually-hidden');
        readMoreFull.classList.toggle('visually-hidden');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-location-map"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', function() {
    Alpine.data('storeLocationMap', function(account, filterTag) {
      return {
        location: null,
        hours: [],
        specialHours: [],
        loading: true,
        account: account,

        init() {
          fetch('https://stockist.co/api/v1/' + account + '/locations/all')
            .then((res) => res.json())
            .then((data) => {
              const locations = data.locations || data;
              this.location = locations.find((loc) => loc.name === filterTag) || null;
              this.loading = false;

              if (this.location) {
                const parsed = this.parseHours(this.location.description);
                this.hours = parsed.regular;
                this.specialHours = parsed.special;
                globalThis.stockistStartingQuery = `${this.location.address_line_1} ${this.location.address_line_2}, ${this.location.state} ${this.location.postal_code} ${this.location.country}`;
                this.$nextTick(() => { this.loadWidget(); });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        },

        loadWidget() {
          const script = document.createElement('script');
          script.src = '//stockist.co/embed/v1/widget.min.js';
          script.async = true;
          document.body.appendChild(script);
        },

        parseHours(description) {
          if (!description) return { regular: [], special: [] };

          const lines = description.split('\n').map((l) => l.trim());
          const markerIndex = lines.findIndex((l) => /^special hours\b/i.test(l));

          const regularLines = markerIndex === -1 ? lines : lines.slice(0, markerIndex);
          const specialLines = markerIndex === -1 ? [] : lines.slice(markerIndex + 1);

          return {
            regular: regularLines.filter((l) => l && l.split(':').length >= 2).map((l) => this.parseHoursLine(l)),
            special: specialLines.filter((l) => l).map((l) => this.parseHoursLine(l))
          };
        },

        parseHoursLine(line) {
          const colonIndex = line.indexOf(':');
          if (colonIndex === -1) {
            return { day: line, time: '' };
          }

          const day = line.slice(0, colonIndex).trim();
          const timeStr = line.slice(colonIndex + 1).trim();
          const times = timeStr.split('—').map((t) => t.trim());

          if (times.length === 2 && /^\d/.test(times[0]) && /^\d/.test(times[1])) {
            return { day: day, time: this.to12Hour(times[0]) + ' - ' + this.to12Hour(times[1]) };
          }
          return { day: day, time: timeStr };
        },

        to12Hour(time24) {
          const parts = time24.split(':');
          let h = parseInt(parts[0], 10);
          const m = parts[1] || '00';
          const suffix = h >= 12 ? 'pm' : 'am';
          h = h % 12 || 12;
          return h + ':' + m + suffix;
        }
      };
    });
  });

  } catch(e) { console.error(e); }
})();
})();
